import { Action } from '@ngrx/store';
import { AdditionalService } from '@cemex-core/cmx-api';

export enum AdditionalServicesSpecificationActionTypes {
  LOAD = '[Specification Additional Services] Load',
  LOAD_COMPLETE = '[Specification Additional Services] Load complete',
  SET_MANEUVERABLE = '[Specification Additional Services] Set maneuverable',
  SET_MANEUVER_VALUE = '[Specification Additional Services] Set maneuver selected value',
  SET_MANEUVER_VALIDATION = '[Specification Additional Services] Set maneuver field validation',
  RESET = '[Specification Additional Services] Reset',
}

export class AdditionalServicesLoadAction implements Action {
  readonly type = AdditionalServicesSpecificationActionTypes.LOAD;

  constructor() { }
}

export class AdditionalServicesLoadCompleteAction implements Action {
  readonly type = AdditionalServicesSpecificationActionTypes.LOAD_COMPLETE;

  constructor(public payload: AdditionalService[]) { }
}

export class SetManeuverableAction implements Action {
  readonly type = AdditionalServicesSpecificationActionTypes.SET_MANEUVERABLE;

  constructor(public payload: boolean) { }
}

export class SetManeuverValueAction implements Action {
  readonly type = AdditionalServicesSpecificationActionTypes.SET_MANEUVER_VALUE;

  constructor(public payload: boolean) { }
}

export class SetManeuverFieldValidationAction implements Action {
  readonly type = AdditionalServicesSpecificationActionTypes.SET_MANEUVER_VALIDATION;

  constructor(public payload: boolean) { }
}

export class AdditionalServicesResetAction implements Action {
  readonly type = AdditionalServicesSpecificationActionTypes.RESET;

  constructor() { }
}

export type AdditionalServicesSpecificationActions =
  | AdditionalServicesLoadAction
  | AdditionalServicesLoadCompleteAction
  | SetManeuverableAction
  | SetManeuverValueAction
  | SetManeuverFieldValidationAction
  | AdditionalServicesResetAction;
